import React, { useEffect } from 'react'
import { Div, Loading } from 'konsys-ui'
import history from '../../history'
import { getAccessToken } from '../../utils/local-data-service'

const Center = ({ children }) => (
  <Div display='flex' justifyContent='center' alignItems='center' width='100vw' height='100vh'>{children}</Div>
)

export default () => {
  useEffect(() => {
    if (!getAccessToken()) {
      history.push('/login')
    } else {
      history.push('/home')
    }
  })


  return (
    <Center>
      <Loading size='large'/>
    </Center>
  )
}
